import script from "./BookingDone.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingDone.vue?vue&type=script&setup=true&lang=ts"

import "./BookingDone.vue?vue&type=style&index=0&id=1978adbe&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-fondueretro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1978adbe"]])

export default __exports__